module.exports = __webpack_public_path__ + "img/img40.e4f3a172.png";